import RestService from 'restService';
import { QuestionNoteJson } from './QuestionNoteJson';
import { formatTimestamp } from '../../../../core/Utils';
import Manager from "../../../../core/Manager";

export default class QuestionNote {
  value: QuestionNoteJson;

  dateString: string;

  initials: string;

  editable: boolean = false;

  showList: boolean = false;

  show: boolean = true;

  public static createFromValue(value: QuestionNoteJson): QuestionNote {
    const note = new QuestionNote();
    note.value = value;
    note.dateString = formatTimestamp(value.createdDate);
    const firstInitial = value.user.firstName.charAt(0);
    const lastInitial = value.user.lastName.charAt(0);
    note.initials = `${firstInitial}${lastInitial}`;
    return note;
  }

  public static create(submissionId: string, pageId: any, questionId: string): QuestionNote {
    const note = new QuestionNote();
    const { user } = Manager.getInstance();
    note.value = {
      createdDate: null,
      id: null,
      note: '',
      pageId,
      questionId,
      submissionId,
      user: {
        email: user.getEmail(),
        firstName: user.firstName,
        lastName: user.lastName,
      },
    };
    note.initials = user.getInitials();
    return note;
  }

  async save() {
    const response = await RestService.post(`/submission/${this.value.submissionId}/page/${this.value.pageId}/question/${this.value.questionId}/note`, {
      note: this.value.note,
    });
    this.updateFromValue(response.data);
    await Manager.getInstance().submission.updateNotes();
  }

  async update() {
    await RestService.put(`/submission/${this.value.submissionId}/page/${this.value.pageId}/question/${this.value.questionId}/note/${this.value.id}`, {
      note: this.value.note,
    });
    await Manager.getInstance().submission.updateNotes();
  }

  async delete() {
    await RestService.delete(`/submission/${this.value.submissionId}/page/${this.value.pageId}/question/${this.value.questionId}/note/${this.value.id}`);
    await Manager.getInstance().submission.updateNotes();
  }

  private updateFromValue(value: QuestionNoteJson) {
    this.value = value;
    this.dateString = formatTimestamp(value.createdDate);
    const firstInitial = value.user.firstName.charAt(0);
    const lastInitial = value.user.lastName.charAt(0);
    this.initials = `${firstInitial}${lastInitial}`;
  }
}
